import styled from 'styled-components';

import colors from '../../styles/colors';

export const TextButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: ${colors.$brandcolor_primary_dark_green_4};

  &:hover {
    color: ${colors.$brandcolor_primary_dark_green_2};
  }
`;
